module.exports = __webpack_public_path__ + "img/denmark-genitourinary-diseases-male.25956232.png";